import { useEffect } from 'react';

// EC動線でのC4画面遷移など、意図的な画面離脱時にダイアログを抑止するためのフラグ
let isCloseConfirmSuppressed = false;

// EC動線のform POST遷移など、ブラウザ標準の離脱確認ダイアログを出したくない箇所から呼び出す
export const suppressCloseConfirm = () => {
  isCloseConfirmSuppressed = true;
};

// form送信の同期例外など、遷移が成立しなかった場合に抑止を明示的に取り消すために呼び出す
export const releaseCloseConfirm = () => {
  isCloseConfirmSuppressed = false;
};

export const CloseConfirm = () => {
  const handleBeforeUnloadEvent = e => {
    if (isCloseConfirmSuppressed) {
      // 抑止は1回の離脱で消費し、以降の離脱では通常どおり確認ダイアログを出す
      isCloseConfirmSuppressed = false;
      return undefined;
    }
    e = e || window.event;
    if (e) {
      e.returnValue = 'Sure?';
    }
    return 'Sure?';
  };

  const handlePageShowEvent = () => {
    // bfcacheから復元された場合はbeforeunloadが発火しないため、
    // pageshowで抑止フラグが残らないようリセットする
    isCloseConfirmSuppressed = false;
  };

  useEffect(() => {
    // bfcache等で画面へ戻ってきた場合に抑止フラグが残らないようリセットする
    isCloseConfirmSuppressed = false;
    window.addEventListener('beforeunload', handleBeforeUnloadEvent);
    window.addEventListener('pageshow', handlePageShowEvent);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
      window.removeEventListener('pageshow', handlePageShowEvent);
    };
  }, []);

  return <></>;
};

export default CloseConfirm;
